import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Hide platform badge
const badge = document.getElementById('emergent-badge');
if (badge) badge.style.setProperty('display', 'none', 'important');
